module.exports = __webpack_public_path__ + "static/img/CY@3x.1bb8d4c7.jpg";